import React from 'react';
import RootLayout from '../../layouts/RootLayout';
import HeroSection from '../../sections/solutions/components/HeroSection';
import Hero_Image from '../../images/product-assets/healthcare-page-hero-img.svg';
import Vendors from '../../components/reusable/vendors/Index';
import AuthenticationSteps from '../../sections/Industries/financial-institutions/AuthenticationSteps';
import AuthenticationStepHeading from '../../sections/Industries/components/AuthenticationStepHeading/AuthenticationStepHeading';
import {
    HEALTHCARE_PAGE_AUTHENTICATION_STEPS,
    HEALTHCARE_PAGE_FAQS,
    HEALTHCARE_PAGE_RESOURCES,
    HEALTHCARE_SEAMLESS_FRAUD_PREVENTION,
    MEDICARE_FRAUDS,
} from '../../sections/Industries/utilities';
import IdentityFrauds from '../../sections/Industries/financial-institutions/IdentityFrauds';
import FraudPrevention from '../../sections/Industries/financial-institutions/FraudPrevention';
import Resources from '../../components/reusable/Resources';
import ProductFaq from '../../sections/Product/components/common/ProductFaq';
import { SAFETY_SECURITY_BANNER_CONTENTS } from '../../helper/constant';
import BottomBanner from '../../components/reusable/BottomBanner';
import MetaTagsProvider from '../../components/MetaTagsProvider';

const SEO_DESCRIPTION =
    'With healthcare fraud recoveries hitting $3.4B in 2023 and $100B lost annually to fake identities, protection is critical. Our Know Your Patient solution provides advanced identity verification to safeguard your practice against the 7.29% global fraud loss average, preventing your institution from joining the 2/3 already victimized by healthcare fraud.';

const Healthcare = () => {
    return (
        <RootLayout getStartedCtaLink="https://portal.authenticate.com/register?utm_source=industry&utm_medium=healthcare&utm_campaign=navbar">
            <MetaTagsProvider
                title="Know Your Patient: Combat Healthcare Fraud & Protect Your Practice"
                description={SEO_DESCRIPTION}
                path="solutions/healthcare"
                ogTitle="Know Your Patient: Combat Healthcare Fraud & Protect Your Practice"
                ogDescription={SEO_DESCRIPTION}
                twitterDescription={SEO_DESCRIPTION}
                keywords="KYP, Know Your Patient, Patient Verification, Patient Identity Verification, healthcare provider identity verification."
                twitterTitle="Know Your Patient: Combat Healthcare Fraud & Protect Your Practice"
                ogImage="https://cdn.authenticating.com/public/website/product_pages/Healthcare_page_OG.png"
            />
            <HeroSection
                category="Industries"
                pageTitle="Healthcare"
                heading="Know Your Patient"
                subHeading="Enhance patients' experience by instantly verifying their identities with our user-friendly Know Your Patient (KYP) solution. Mitigate fraud and ensure compliance by implementing cutting-edge digital patient identity verification tailored for healthcare providers, pharmacies, and telemedicine services. Protect sensitive patient information while providing a smooth onboarding process."
                heroImage={Hero_Image}
                getStartedCtaLink="https://portal.authenticate.com/register?utm_source=industry&utm_medium=healthcare&utm_campaign=hero"
            />
            <Vendors />
            <AuthenticationSteps
                HeadingComponent={<AuthenticationStepHeading text="How Healthcare Providers" />}
                steps={HEALTHCARE_PAGE_AUTHENTICATION_STEPS}
            />
            <IdentityFrauds
                heading="Medicare Fraud Costs $60 Billion Every Year"
                whitepaperPath="/whitepapers/healthcare"
                dataOne={MEDICARE_FRAUDS.DATA_1}
                dataTwo={MEDICARE_FRAUDS.DATA_2}
            />
            <FraudPrevention
                heading="Seamless Fraud Prevention with "
                cardOne={HEALTHCARE_SEAMLESS_FRAUD_PREVENTION.DATA_ONE}
                cardTwo={HEALTHCARE_SEAMLESS_FRAUD_PREVENTION.DATA_TWO}
            />
            <Resources item={HEALTHCARE_PAGE_RESOURCES} />
            <ProductFaq
                titleColor="#262626"
                subHeading="Everything You Need to Know About Fraud Protection in Healthcare."
                faqData={HEALTHCARE_PAGE_FAQS}
            />
            <BottomBanner
                data={SAFETY_SECURITY_BANNER_CONTENTS}
                getStartedCtaLink="https://portal.authenticate.com/register?utm_source=industry&utm_medium=healthcare&utm_campaign=footer"
            />
        </RootLayout>
    );
};

export default Healthcare;
